module.exports = __webpack_public_path__ + "files/032c500c7dad1cabca32ee6c050bb86a.png";